import BickodeField from "./felter/BickodeField";

const LandUtenBankkode = () => {
    return <BickodeField />;
};

export default LandUtenBankkode;
